import * as React from 'react';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { TextP } from '../../Defaults/Text';
import { ZlataPriadkaFooterRowWrapper as FooterRowWrapper } from './FooterRowWrapper';

interface Props {
  withoutSitemapLink?: boolean;
  leftText: string;
}

function FooterLastRow({ leftText }: Props) {
  return (
    <FooterRowWrapper>
      <SmallTextP>{leftText}</SmallTextP>
      <Delimeter />
      <SmallTextA rel="noreferrer" href="https://www.bart.sk/" target="_blank">
        {'Vytvoril bart.sk - Tvorme spolu digitálne zážitky'}
      </SmallTextA>
    </FooterRowWrapper>
  );
}

const textLikeCss = css`
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(18)};
  font-weight: 300;
  text-align: center;

  ${({ theme }) => theme.mediab.m580`
    margin-bottom: ${rem(16)};

    &:last-child {
      margin-bottom: 0;
    }
  `}
`;

const SmallTextA = styled.a`
  ${textLikeCss};

  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

const SmallTextP = styled(TextP)`
  ${textLikeCss};
`;

const Delimeter = styled.span`
  margin: 0 ${rem(16)};
  width: ${rem(1)};
  height: ${rem(14)};
  background-color: ${({ theme }) => theme.colors.textPrimary};
  display: inline-block;
  position: relative;
  top: ${rem(1)};

  ${({ theme }) => theme.mediab.m580`
    display: none;
  `}
`;

function areEqual(prev: Props, next: Props) {
  return (
    prev.leftText === next.leftText &&
    prev.withoutSitemapLink === next.withoutSitemapLink
  );
}
const MemoizedFooterLastRow = React.memo(FooterLastRow, areEqual);
export { MemoizedFooterLastRow as FooterLastRow };
